module.exports = __webpack_public_path__ + "img/concept-bg.6dfbf57b.png";